import React, { useEffect, useRef, useState } from 'react';
import { Form, Input, Radio, Select, Typography } from 'antd';
import { CloudOutlined } from '@ant-design/icons';
import ReactDOM from 'react-dom';
import DdnHeField from '../components/DdnHeField';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const { Text } = Typography;

export default (formPlugin, namespace) => {

    return {
        Renderer: (props) => {
            let containerRef = useRef(null)
            const [listField, setlistField] = useState(undefined)
            useEffect(() => {
                setlistField(props.pluginConfig.getListField(containerRef.current))
            }, [])

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            if ((props.isPreviewMode || props.readOnly) && !props.data.fieldKey) {
                return null
            }

            const { data } = props
            var reducedWidth = data.reduced ? "48%" : "100%"
            const listFieldProps = listField ? { ...listField, key: undefined } : null
            const finalName = "[HAZKARA]_" + data.fieldKey
            const extraName = listField ? [listField.name, finalName].flat() : finalName

            return (
                <div ref={(ref) => containerRef.current = ref}>

                    <Form.Item
                        {...listFieldProps}
                        label={t`Civilité` + " :"}
                        name={listField ? [listField.name, finalName, "homme"].flat() : [finalName, "homme"]}
                        rules={[{
                            required: data.required,
                            message: t`Ce champ est obligatoire`
                        }]}
                    >
                        <Select size="large" placeholder={t`Civilité`}>
                            <Select.Option value={true}><Trans>Monsieur</Trans></Select.Option>
                            <Select.Option value={false}><Trans>Madame</Trans></Select.Option>
                        </Select>
                    </Form.Item>

                    <Form.Item noStyle shouldUpdate={true}>
                        {(_form) => {
                            let prefix = finalName
                            if (listField) prefix = [listField.name, finalName]
                            const namespaces = props.pluginConfig?.namespace?.split("/").filter(i => i) || []

                            let identity = _form.getFieldValue("identity")
                            let homme = _form.getFieldValue([namespaces, prefix, "homme"].flat())

                            let label = t`Il/elle est`
                            if (homme === true) label = t`Il est`
                            if (homme === false) label = t`Elle est`

                            let options = formPlugin.RELATIONS_OPTIONS

                            return (
                                <Form.Item
                                    {...listFieldProps}
                                    label={label + " :"}
                                    name={listField ? [listField.name, finalName, "_relation"].flat() : [finalName, "_relation"]}
                                    rules={[{
                                        required: true,
                                        message: t`Ce champ est obligatoire`
                                    }]}
                                >
                                    <Select size="large" placeholder={label}>
                                        {options.map(i => {
                                            let _label = i.labelH + " / " + i.labelF
                                            if (homme === true) _label = i.labelH
                                            if (homme === false) _label = i.labelF

                                            let _name = identity?.nom && identity?.prenom ? `${identity.prenom} ${identity.nom}` : null

                                            return (
                                                <Select.Option value={i.value}>
                                                    {_label + " "}
                                                    {!!_name && (
                                                        <Text>
                                                            <Trans>de</Trans> <Text strong> {_name}</Text>
                                                        </Text>
                                                    )}
                                                </Select.Option>
                                            )
                                        })}
                                        <Select.Option value="OTHER"><Trans>Autre</Trans></Select.Option>
                                    </Select>
                                </Form.Item>
                            )
                        }}
                    </Form.Item>

                    <div style={{ display: data.reduced ? "flex" : "block", justifyContent: "space-between" }}>
                        <Form.Item
                            {...listFieldProps}
                            label={(data.labelPrenom || t`Prénom`) + " :"}
                            name={listField ? [listField.name, finalName, "prenom"].flat() : [finalName, "prenom"]}
                            rules={[{
                                required: data.required,
                                message: t`Ce champ est obligatoire`
                            }, {
                                pattern: /^[A-zÀ-ú\s]*$/,
                                message: t`Le champ doit contenir uniquement des lettres`
                            }]}
                            style={{ width: reducedWidth }}
                        >
                            <Input type="text" placeholder={data.labelPrenom || t`Prénom`} />
                        </Form.Item>

                        <Form.Item
                            {...listFieldProps}
                            label={(data.labelNom || t`Nom`) + " :"}
                            name={listField ? [listField.name, finalName, "nom"].flat() : [finalName, "nom"]}
                            rules={[{
                                required: data.required,
                                message: t`Ce champ est obligatoire`
                            }, {
                                pattern: /^[A-zÀ-ú\s]*$/,
                                message: t`Le champ doit contenir uniquement des lettres`
                            }]}
                            style={{ width: reducedWidth }}
                        >
                            <Input type="text" placeholder={data.labelNom || t`Nom`} />
                        </Form.Item>
                    </div>

                    <div style={{ display: data.reduced ? "flex" : "block", justifyContent: "space-between" }}>
                        <Form.Item
                            {...listFieldProps}
                            label={t`Prénom Hébraïque` + " :"}
                            name={listField ? [listField.name, finalName, "prenomHE"].flat() : [finalName, "prenomHE"]}
                            rules={[{
                                required: data.required,
                                message: t`Ce champ est obligatoire`
                            }]}
                            style={{ width: reducedWidth }}
                        >
                            <Input type="text" placeholder={t`Prénom Hébraïque`} />
                        </Form.Item>

                        <Form.Item
                            {...listFieldProps}
                            label={t`Lieu de l'enterrement` + " :"}
                            name={listField ? [listField.name, finalName, "deceasedLocation"].flat() : [finalName, "deceasedLocation"]}
                            style={{ width: reducedWidth }}
                        >
                            <Input type="text" placeholder={t`Lieu de l'enterrement`} />
                        </Form.Item>
                    </div>

                    <div style={{ display: data.reduced ? "flex" : "block", justifyContent: "space-between" }}>
                        <Form.Item
                            {...listFieldProps}
                            label={t`Date du Décès` + " :"}
                            name={listField ? [listField.name, finalName, "deceasedDate"].flat() : [finalName, "deceasedDate"]}
                            rules={[{
                                required: true,
                                message: t`Ce champ est obligatoire`
                            }]}
                            style={{ width: reducedWidth }}
                        >
                            <DdnHeField placeholder={t`Date du Décès`} />
                        </Form.Item>

                        <Form.Item
                            {...listFieldProps}
                            label={t`Heure du Décès` + " :"}
                            name={listField ? [listField.name, finalName, "deceasedHour"].flat() : [finalName, "deceasedHour"]}
                            rules={[{
                                required: data.required,
                                message: t`Ce champ est obligatoire`
                            }]}
                            style={{ width: reducedWidth }}
                        >
                            <Radio.Group>
                                <Radio.Button value={false}><Trans>Pendant la journée</Trans></Radio.Button>
                                <Radio.Button value={true}><Trans>Pendant la nuit</Trans></Radio.Button>
                            </Radio.Group>
                        </Form.Item>
                    </div>

                    <div style={{ display: data.reduced ? "flex" : "block", justifyContent: "space-between" }}>
                        <Form.Item
                            {...listFieldProps}
                            label={t`Prénom Hébraïque du Père` + " :"}
                            name={listField ? [listField.name, finalName, "deceasedPere"].flat() : [finalName, "deceasedPere"]}
                            rules={[{
                                required: data.required,
                                message: t`Ce champ est obligatoire`
                            }]}
                            style={{ width: reducedWidth }}
                        >
                            <Input type="text" placeholder={t`Prénom Hébraïque du Père`} />
                        </Form.Item>

                        <Form.Item
                            {...listFieldProps}
                            label={t`Prénom Hébraïque de la Mère` + " :"}
                            name={listField ? [listField.name, finalName, "deceasedMere"].flat() : [finalName, "deceasedMere"]}
                            rules={[{
                                required: data.required,
                                message: t`Ce champ est obligatoire`
                            }]}
                            style={{ width: reducedWidth }}
                        >
                            <Input type="text" placeholder={t`Prénom Hébraïque de la Mère`} />
                        </Form.Item>
                    </div>
                </div>
            )
        },
        namespace: namespace,
        id: 'form-hazkara' + namespace,
        title: t`Champ Hazkara`,
        description: t`Élément de formulaire utilisable.`,
        icon: <CloudOutlined />,
        iconColor: "#F39C12",
        version: 1,
        getListField: (containerRef) => {
            const listField = ReactDOM.findDOMNode(containerRef)?.closest(".form-field")?.dataset.field
            if (listField) return JSON.parse(listField)
            return null
        },
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    required: {
                        type: 'boolean',
                        uniforms: { label: t`Obligatoire` }
                    },
                    reduced: {
                        type: 'boolean',
                        uniforms: { label: t`Formulaire Réduit` }
                    },
                    fieldKey: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Identifiant`,
                            placeholder: t`Identifiant du Champ`
                        }
                    },
                }
            },
        },
    }
}
